(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'react', '@material-ui/icons/ExpandMore', '@material-ui/icons/ExpandLess', './SplitButtonMenu'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('@material-ui/icons/ExpandMore'), require('@material-ui/icons/ExpandLess'), require('./SplitButtonMenu'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.ExpandMore, global.ExpandLess, global.SplitButtonMenu);
    global.SplitButtonMenuContainer = mod.exports;
  }
})(this, function (exports, _extends2, _objectWithoutProperties2, _react, _ExpandMore, _ExpandLess, _SplitButtonMenu) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _react2 = _interopRequireDefault(_react);

  var _ExpandMore2 = _interopRequireDefault(_ExpandMore);

  var _ExpandLess2 = _interopRequireDefault(_ExpandLess);

  var _SplitButtonMenu2 = _interopRequireDefault(_SplitButtonMenu);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SplitButtonMenuContainer = function SplitButtonMenuContainer(_ref) {
    var menuItems = _ref.menuItems,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['menuItems']);

    var _useState = (0, _react.useState)(false),
        menuOpen = _useState[0],
        setMenuOpen = _useState[1];

    var buttonRef = (0, _react.useRef)(null);

    var splitMenuButtonId = 'split-menu-button';

    var toggleMenuExpanded = function toggleMenuExpanded(event) {
      event.stopPropagation();
      setMenuOpen(!menuOpen);
    };

    var validateClickAwayListener = function validateClickAwayListener(event) {
      var clickedNode = event.target;
      var menuButtonRef = buttonRef.current;
      var isNodeChildOfProfileButton = menuButtonRef && menuButtonRef.contains(clickedNode);

      if (isNodeChildOfProfileButton) {
        return;
      }

      toggleMenuExpanded(event);
    };

    var MenuIcon = menuOpen ? _ExpandLess2.default : _ExpandMore2.default;

    var mergedProps = (0, _extends3.default)({
      MenuIcon: MenuIcon,
      menuItems: menuItems,
      menuOpen: menuOpen,
      buttonRef: buttonRef,
      splitMenuButtonId: splitMenuButtonId,
      toggleMenuExpanded: toggleMenuExpanded,
      validateClickAwayListener: validateClickAwayListener
    }, rest);

    return _react2.default.createElement(_SplitButtonMenu2.default, mergedProps);
  };

  exports.default = SplitButtonMenuContainer;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/SplitButton/SplitButtonMenu.container.js
// module id = 1941
// module chunks = 1